import { dictWithUrl } from '@/components/lots/api';
export async function getDictionary(optionNum, tenantCode = '') {
    if (optionNum) {
        const result = await dictWithUrl(optionNum).then(res => {
            if (res && +res.code === 0) {
                const arr = [];
                for (const key in res.data[optionNum]) {
                    if (res.data[optionNum].hasOwnProperty(key)) {
                        arr.push({
                            value: key,
                            label: res.data[optionNum][key]
                        });
                    }
                }
                return arr;
            }
        });
        return result;
    } else {
        return [];
    }
}
